import { PriorityFilterEnum } from "app/types";
import { getPriorityIcon } from "./containers/Home/containers/helpers";
import { IPriority } from "./types";

export const fixedColorCode = [
  "#6554C0",
  "#36B37E",
  "#00B8D9",
  "#FF5630",
  "#6B778C",
  "#4C9AFF",
  "#FFC400",
  "#EE5396",
  "#091E42",
  "#008DA6",
  "#DE350B",
  "#FF991F",
  "#403294",
  "#008274",
  "#1D7AFC",
];

export const TICKET_HEADERS = [
  { id: "select", name: "", width: 62, resizable: false, sortable: false },
  {
    name: "Name",
    id: "name",
    resizable: true,
    width: 428,
    className: "!p-[4px] text-xs leading-[18px] font-medium",
  },
];

export const priorityOptions: IPriority[] = [
  {
    label: PriorityFilterEnum.URGENT,
    value: PriorityFilterEnum.URGENT,
    _id: PriorityFilterEnum.URGENT,
    icon: getPriorityIcon(PriorityFilterEnum.URGENT),
    color: "#FF4F4F",
  },
  {
    label: PriorityFilterEnum.HIGH,
    value: PriorityFilterEnum.HIGH,
    _id: PriorityFilterEnum.HIGH,
    icon: getPriorityIcon(PriorityFilterEnum.HIGH),
    color: "#FF8A00",
  },
  {
    label: PriorityFilterEnum.NORMAL,
    value: PriorityFilterEnum.NORMAL,
    _id: PriorityFilterEnum.NORMAL,
    icon: getPriorityIcon(PriorityFilterEnum.NORMAL),
    color: "#2AD95B",
  },
  {
    label: PriorityFilterEnum.LOW,
    value: PriorityFilterEnum.LOW,
    _id: PriorityFilterEnum.LOW,
    icon: getPriorityIcon(PriorityFilterEnum.LOW),
    color: "#20C6EB",
  },
];
